import { render } from "./Spinner.vue?vue&type=template&id=13a9d4af&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=13a9d4af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13a9d4af"

export default script